const initialState = JSON.parse(localStorage.getItem("wishlistItems")) || [];

const addToWhishList = (state = initialState, action) => {
  if (action.type === "ADDTOWHISHLIST") {
    let existingProduct = state.find(
      (currentItem) => currentItem.id === action.payload.id
    );
    if (existingProduct) {
      let updatedWhishlist = state.map((currentElement) => {
        if (currentElement.id === action.payload.id) {
          return {
            ...currentElement,
          };
        } else {
          return currentElement;
        }
      });
      return updatedWhishlist;
    } else {
      return [...state, action.payload];
    }
  }

  if (action.type === "EMPTYWHISHLIST") {
    return [];
  }

  if (action.type === "REMOVEWHISHLISTITEM") {
    const updatedArray = state.filter((currentItem) => {
      return currentItem.id !== action.payload;
    });
    return updatedArray;
  }

  return state;
};

export default addToWhishList;
